/**
 * @generated SignedSource<<2152fc955a3c083c45eaadc38888d979>>
 * @relayHash 9f6a4b2083c39f17d298358b2531bc64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0e2c708a9c276f1bdcc3b0e1b56658401dfd6791656e7efd59175f625e65a112

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionsWithRelayEditViewFieldOptionsPrefetchQuery$variables = {
  first?: number | null | undefined;
  id: string;
  isSelectableField: boolean;
};
export type versionsWithRelayEditViewFieldOptionsPrefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment">;
};
export type versionsWithRelayEditViewFieldOptionsPrefetchQuery = {
  response: versionsWithRelayEditViewFieldOptionsPrefetchQuery$data;
  variables: versionsWithRelayEditViewFieldOptionsPrefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSelectableField"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v5 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v3/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
    "selections": [
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ui_issueSelectableFieldEditView_SelectableFieldEditViewWithFieldOptionsFragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
    "selections": [
      {
        "condition": "isSelectableField",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v4/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  }
                ],
                "type": "JiraIssueField",
                "abstractKey": "__isJiraIssueField"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraSelectableValueConnection",
                    "kind": "LinkedField",
                    "name": "selectableValueOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSelectableValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "selectableLabel"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "selectableGroupKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "selectableIconUrl"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isDisabled"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "optionId"
                                  }
                                ],
                                "type": "JiraOption"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                  }
                                ],
                                "type": "JiraVersion"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v8/*: any*/),
                    "filters": [
                      "searchBy",
                      "filterById"
                    ],
                    "handle": "connection",
                    "key": "selectableValue_issueFieldEditviewFull_fieldOptions__selectableValueOptions",
                    "kind": "LinkedHandle",
                    "name": "selectableValueOptions"
                  }
                ],
                "type": "JiraHasSelectableValueOptions",
                "abstractKey": "__isJiraHasSelectableValueOptions"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0e2c708a9c276f1bdcc3b0e1b56658401dfd6791656e7efd59175f625e65a112",
    "metadata": {},
    "name": "versionsWithRelayEditViewFieldOptionsPrefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a4594cf7984d240ea2159d7070119e86";

export default node;
